import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { User } from "@/types/user";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const calculateProfileCompletion = (user: User | null): number => {
  if (!user) return 0;
  
  let score = 20; // Base for account creation

  if (user.name) score += 30;

  // Check for ANY platform connection (YouTube or manual)
  // Social Section Score: Max 50
  
  if (user.youtube_data) {
    score += 50;
  } else if (user.social_profiles && user.social_profiles.length > 0) {
    // Calculate score for manual profiles
    // Only give full 50 points if at least one profile has required fields (platform and handle)
    let hasCompleteProfile = false;

    user.social_profiles.forEach(p => {
      // Check if this profile has required fields (URL and follower_count are optional)
      const hasPlatform = !!p.platform;
      const hasHandle = !!p.handle && p.handle.trim() !== "";
      
      // Count as complete if platform and handle are filled
      if (hasPlatform && hasHandle) {
        hasCompleteProfile = true;
      }
    });

    // Only add the 50 points if at least one profile is complete
    if (hasCompleteProfile) {
      score += 50;
    }
  }

  return score;
};
